// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  presenceId: __t.u64(),
  cacheKey: __t.string(),
  provider: __t.string(),
  model: __t.string(),
  voice: __t.string(),
  textPreview: __t.string(),
  mimeType: __t.string(),
  sampleRate: __t.u32(),
  blobPath: __t.string(),
  durationMs: __t.u32(),
};
